import React from 'react'
import Navbar from '../components/Navbar'
import Cart from '../components/Cart'

function CartPage() {
  return (
    <div>
   <Navbar/>
   <Cart/>
    </div>
  )
}

export default CartPage